"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _recharts = require("recharts");
var _alpha = require("../../utils/alpha");
var _ActiveShape = _interopRequireDefault(require("./ActiveShape"));
var _renderTextContent = _interopRequireDefault(require("./renderTextContent"));
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const PieChart = ({
  width,
  height,
  data,
  subtitlePrefix,
  defaultSubtitle,
  active,
  opacity,
  onActiveChange,
  customMiddleText,
  customMiddleValue,
  ...rest
}) => {
  const [activeIndex, setActiveIndex] = (0, _react.useState)();
  const [hoverIndex, setHoverIndex] = (0, _react.useState)(null);

  /** When active is handled from the outside */
  (0, _react.useEffect)(() => {
    setActiveIndex(active);
  }, [active]);
  const onPieClick = (0, _react.useCallback)((_, index) => {
    if (index === activeIndex) {
      setActiveIndex(undefined);
      onActiveChange?.(undefined);
      return;
    }
    onActiveChange?.(index);
    setActiveIndex(index);
  }, [activeIndex, onActiveChange]);
  const onCellHover = (0, _react.useCallback)((_, index) => setHoverIndex(index), [setHoverIndex]);

  /** Avoids re-renders by memoizing parameters */
  const calculateTitle = (0, _react.useMemo)(() => {
    if (customMiddleText) return customMiddleText;
    const activeItemTitle = activeIndex !== undefined ? data[activeIndex].title : defaultSubtitle;
    return subtitlePrefix ? `${subtitlePrefix} ${activeItemTitle?.toLocaleLowerCase()}` : activeItemTitle;
  }, [activeIndex, data, defaultSubtitle, subtitlePrefix]);
  const activeItemValue = activeIndex !== undefined ? data[activeIndex].value : data.map(({
    value
  }) => value).reduce((sum, value) => sum + value);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.PieChartWrapper, {
    height: height,
    width: width,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_recharts.ResponsiveContainer, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_recharts.PieChart, {
        "aria-label": "Pie chart",
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_recharts.Pie, {
          isAnimationActive: false,
          data: data,
          onClick: onPieClick,
          activeIndex: activeIndex,
          activeShape: _ActiveShape.default,
          onMouseEnter: onCellHover,
          onMouseOut: () => setHoverIndex(null)
          // Thickness of the graph, higher % = thinner
          ,
          innerRadius: "65%",
          dataKey: "value",
          ...rest,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_recharts.LabelList, {
            valueAccessor: () => {}
            // @ts-ignore
            ,
            content: (0, _renderTextContent.default)(customMiddleValue || activeItemValue, calculateTitle)
          }), data.map((entry, index) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_recharts.Cell, {
            fill: hoverIndex === index || activeIndex === index ? entry.color : (0, _alpha.alpha)(entry.color || '#000000', 70),
            role: "presentation",
            "aria-label": `${entry.title}: ${entry.value}`
          }, `cell-${index}`))]
        })
      })
    })
  });
};
var _default = exports.default = PieChart;